import React, {useEffect} from 'react';
import {Card, CardBody, Col, Container, Row} from 'reactstrap';

const SessionExpiredPage = () => {
    useEffect(() => {
        try {
            sessionStorage.removeItem('sessionExpired');
        } catch (e) { /* ignore */ }
    }, []);
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(160deg, #e8eaf6 0%, #c5cae9 100%)',
            padding: '16px',
            boxSizing: 'border-box'
        }}>
            <Container fluid className="px-3 px-md-4">
                <Row className="justify-content-center">
                    <Col xs="12" sm="11" md="8" lg="5">
                        <Card className="shadow-sm border-0" style={{borderRadius: 12, overflow: 'hidden'}}>
                            <CardBody className="text-center px-4 py-5 px-sm-5 py-sm-5" style={{maxWidth: 400, margin: '0 auto'}}>
                                <div style={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '50%',
                                    background: 'rgba(103, 58, 183, 0.08)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 20px',
                                    fontSize: 24,
                                    color: '#7e57c2'
                                }}>
                                    ○
                                </div>
                                <h5 className="mb-2" style={{color: '#37474f', fontWeight: 500, fontSize: 'clamp(1.1rem, 4vw, 1.35rem)'}}>
                                    Session expired
                                </h5>
                                <p className="text-muted mb-0" style={{fontSize: 'clamp(0.9rem, 2.5vw, 1rem)', lineHeight: 1.6, color: '#607d8b'}}>
                                    Please check your internet connection and refresh the page when you're ready.
                                </p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default SessionExpiredPage;
